import "./faq-section.scss";

const LINK_SELECTOR = ".js-jiffytransfers-landing-v2-faq-link";
const SHOWN_CLASS = "jiffytransfers-landing-v2-faq-section__faq-item--shown";
const BOUND_FLAG = "__jiffyTransfersFaqAccordionBound";

// The landing bundle evaluates this module more than once on the live page, so a
// plain `addEventListener` attached the toggle twice. Every click then toggled
// the class an even number of times — net no change — which is why the accordion
// looked frozen (the prior per-element bind had the same fate). Guarding on a
// global flag ensures exactly one delegated listener is ever attached, no matter
// how many times this module runs. Delegation on `document` also means the toggle
// works regardless of when the FAQ items render.
if (!window[BOUND_FLAG]) {
  window[BOUND_FLAG] = true;

  document.addEventListener("click", event => {
    const link = event.target.closest(LINK_SELECTOR);
    if (!link) return;

    link.parentElement?.parentElement?.classList.toggle(SHOWN_CLASS);
  });
}
